import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const BulkActionBarHolder = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 16px;
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  .left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .clear-icon {
    cursor: pointer;
    font-size: 16px;
    color: ${Colors.textMuted};

    &:hover {
      color: ${Colors.textStrong};
    }
  }

  .count {
    font-weight: 500;
    color: ${Colors.textStrong};
  }
`

export default BulkActionBarHolder
